import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';

function VisaPrepFamilyStep4(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.GUARDIANS_PERSONAL_DETAILS}
        label={`Do you have a Guardian that you have not entered as your Mother or Father?`}
        value={boolToYesNo(props.hasGuardiansPersonalDetails)}
      />
      {props.hasGuardiansPersonalDetails === true ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_NATIONALITY}
            value={props.guardianNationality}
            label={`Guardian's Nationality`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_SAME_NATIONALITY}
            label={'Have they always had the same nationality?'}
            value={boolToYesNo(props.guardianSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_FAMILY_NAME}
            value={props.guardianFamilyName}
            label={`Guardian's Family Name`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_GIVEN_NAME}
            value={props.guardianGivenName}
            label={`Guardian's Given Name`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_DOB}
            label={`Guardian's Date of Birth`}
            value={props.guardianDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_PLACE_OF_BIRTH}
            value={props.guardianPlaceOfBirth}
            label={`Guardian's Place of birth`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_TRAVELLING_WITH}
            label={'Is this person travelling with you?'}
            value={props.guardianTravellingWith}
          />
          {isPersonTravellingWith(props.guardianTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.GUARDIAN_UK_VISA}
                label={'Do they have a visa for the UK?'}
                value={props.guardianUkVisa}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.GUARDIAN_HAS_PASSPORT}
                label={'Do they have a Passport or Travel Document?'}
                value={boolToYesNo(props.guardianHasPassport)}
              />
              {props.guardianHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.GUARDIAN_PASSPORT_NUMBER}
                  value={props.guardianPassportNumber}
                  label={'Current Passport or Travel Document Number:'}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep4;
